import { render, staticRenderFns } from "./OsobaTvrtkaDetails.vue?vue&type=template&id=778d6b6e&scoped=true&"
import script from "./OsobaTvrtkaDetails.vue?vue&type=script&lang=js&"
export * from "./OsobaTvrtkaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d6b6e",
  null
  
)

export default component.exports